module.exports = __webpack_public_path__ + "static/media/alert-pink.ba7f17a2.svg";